import { render, staticRenderFns } from "./search-announcement.vue?vue&type=template&id=5abb4581&lang=pug"
import script from "./search-announcement.vue?vue&type=script&lang=js"
export * from "./search-announcement.vue?vue&type=script&lang=js"
import style0 from "./search-announcement.vue?vue&type=style&index=0&id=5abb4581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports